
(() => {
  const root = document.getElementById('s7g');
  if (!root) return;
  const galleryNode = root.querySelector('#s7g-gallery-data');
  const commerceNode = root.querySelector('#s7g-commerce-data');
  const gallery = galleryNode ? JSON.parse(galleryNode.textContent) : [];
  const commerce = commerceNode ? JSON.parse(commerceNode.textContent) : {variants:[], planId:null};
  const moneyFromCents = (cents) => new Intl.NumberFormat('de-DE', {style:'currency', currency:'EUR'}).format((cents || 0) / 100);
  const main = root.querySelector('#main-image');
  const thumbs = root.querySelector('.gallery-thumbnails');
  let galleryIndex = 0;

  function paintLayers(container, item) {
    if (!container || !item) return;
    container.querySelectorAll('.art-layer,.art-table').forEach((el) => el.remove());
    for (const data of item.tables || []) {
      const table = document.createElement('table');
      table.className = 'art-table';
      table.setAttribute('aria-label', data.color === '#01387a' ? 'Wirkstoffe pro Portion' : 'Nährwerte pro Portion');
      if (container.classList.contains('thumbnail-image')) table.setAttribute('aria-hidden', 'true');
      table.style.left = (data.x / 20) + '%';
      table.style.top = (data.y / 20) + '%';
      table.style.width = (data.width / 20) + '%';
      table.style.height = (data.height / 20) + '%';
      table.style.color = data.color;
      table.style.fontSize = (data.fontSize / 20) + 'cqw';
      const body = document.createElement('tbody');
      data.rows.forEach((row) => {
        const tr = document.createElement('tr');
        tr.style.height = (100 / data.rows.length) + '%';
        tr.style.fontWeight = row.weight || 700;
        const label = document.createElement('th');
        label.scope = 'row';
        label.textContent = row.label;
        const value = document.createElement('td');
        value.textContent = row.value;
        tr.append(label, value);
        body.append(tr);
      });
      table.append(body);
      container.append(table);
    }
  }

  function selectImage(index, focus) {
    if (!gallery.length || !main || !thumbs) return;
    galleryIndex = (index + gallery.length) % gallery.length;
    const item = gallery[galleryIndex];
    main.src = item.src;
    main.alt = item.alt || item.caption;
    paintLayers(root.querySelector('.gallery-art'), item);
    const buttons = [...thumbs.children];
    buttons.forEach((b, i) => b.setAttribute('aria-pressed', String(i === galleryIndex)));
    const active = buttons[galleryIndex];
    if (focus) active.focus({preventScroll: true});
    thumbs.scrollTo({
      left: Math.max(0, active.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - active.clientWidth) / 2),
      behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'
    });
  }

  if (main && thumbs && gallery.length) {
    gallery.forEach((item, index) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', item.caption);
      b.setAttribute('aria-pressed', String(index === 0));
      const face = document.createElement('span');
      face.className = 'thumbnail-image';
      const im = document.createElement('img');
      im.src = item.src;
      im.alt = '';
      im.loading = index < 6 ? 'eager' : 'lazy';
      face.append(im);
      paintLayers(face, item);
      const caption = document.createElement('span');
      caption.className = 'thumbnail-caption';
      caption.textContent = item.caption;
      b.append(face, caption);
      b.addEventListener('click', () => selectImage(index));
      b.addEventListener('keydown', (e) => {
        if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          selectImage(e.key === 'Home' ? 0 : e.key === 'End' ? gallery.length - 1 : index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      thumbs.append(b);
    });
    selectImage(0);
    root.querySelector('.gallery-prev')?.addEventListener('click', () => selectImage(galleryIndex - 1));
    root.querySelector('.gallery-next')?.addEventListener('click', () => selectImage(galleryIndex + 1));
    let touchStart = null;
    main.addEventListener('touchstart', (e) => {
      touchStart = {x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY};
    }, {passive: true});
    main.addEventListener('touchend', (e) => {
      if (!touchStart) return;
      const dx = e.changedTouches[0].clientX - touchStart.x;
      const dy = e.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) selectImage(galleryIndex + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive: true});
  }

  root.querySelectorAll('.close-dialog').forEach((b) => b.addEventListener('click', () => b.closest('dialog')?.close()));
  root.querySelectorAll('dialog').forEach((d) => d.addEventListener('click', (e) => {
    if (e.target === d) {
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
    }
  }));
  const imageDialog = root.querySelector('#image-dialog');
  root.querySelector('.gallery-zoom')?.addEventListener('click', () => {
    const detail = root.querySelector('#detail-image');
    if (detail && main) {
      detail.src = main.src;
      detail.alt = main.alt;
    }
    paintLayers(root.querySelector('.detail-art'), gallery[galleryIndex]);
    root.querySelector('.detail-scroll')?.classList.remove('is-zoomed');
    const zoom = root.querySelector('#detail-zoom');
    if (zoom) {
      zoom.setAttribute('aria-pressed', 'false');
      zoom.textContent = 'Details vergrößern +';
    }
    imageDialog?.showModal();
  });
  root.querySelector('#detail-zoom')?.addEventListener('click', (e) => {
    const zoomed = root.querySelector('.detail-scroll')?.classList.toggle('is-zoomed');
    e.currentTarget.setAttribute('aria-pressed', String(!!zoomed));
    e.currentTarget.textContent = zoomed ? 'Gesamtbild ansehen −' : 'Details vergrößern +';
  });
})();

(() => { if (!document.getElementById('s7g')) return;
(()=>{
  const gallery=document.querySelector('#buybox .product-gallery');
  const copy=document.querySelector('#buybox .product-copy');
  const stage=gallery?.querySelector('.gallery-stage');
  const thumbs=gallery?.querySelector('.gallery-thumbnails');
  const eyebrow=copy?.querySelector(':scope > .eyebrow');
  if(!gallery||!stage||!thumbs||!eyebrow||gallery.dataset.mgv6Mounted)return;
  gallery.dataset.mgv6Mounted='true';

  const mobile=matchMedia('(max-width:699px)');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const originalPosition=document.createComment('Mobile eyebrow returns here above 699px.');
  eyebrow.before(originalPosition);
  const track=document.createElement('div');
  track.className='mgv6-track';
  track.tabIndex=0;
  track.setAttribute('role','region');
  track.setAttribute('aria-roledescription','Karussell');
  track.setAttribute('aria-label','Produktbilder. Mit den Pfeiltasten das Bild wechseln.');
  const status=document.createElement('p');
  status.className='mgv6-status visually-hidden';
  status.setAttribute('role','status');
  status.setAttribute('aria-live','polite');
  status.setAttribute('aria-atomic','true');
  // Keep the original .gallery-art first: the existing controller renders into it.
  stage.append(track);
  gallery.append(status);
  let suppressBaseIndex=null;
  let requestedIndex=null;
  let touchActive=false;
  let settleTimer;
  let alignmentFrame;

  const buttons=()=>[...thumbs.querySelectorAll(':scope > button')];
  const selected=()=>Math.max(0,buttons().findIndex(button=>button.getAttribute('aria-pressed')==='true'));
  const bounded=index=>Math.max(0,Math.min(track.children.length-1,index));
  const targetLeft=index=>{
    const slide=track.children[bounded(index)];
    return slide?slide.offsetLeft-(track.clientWidth-slide.clientWidth)/2:0;
  };
  const nearest=()=>{
    let best=0,distance=Infinity;
    [...track.children].forEach((slide,index)=>{
      const delta=Math.abs(targetLeft(index)-track.scrollLeft);
      if(delta<distance){best=index;distance=delta;}
    });
    return best;
  };
  function mark(index){
    track.dataset.activeIndex=String(index);
    [...track.children].forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
    const caption=buttons()[index]?.getAttribute('aria-label')||'';
    status.textContent=`Bild ${index+1} von ${track.children.length}: ${caption}`;
  }
  function align(index,behavior='auto'){
    if(!mobile.matches||!track.children.length)return;
    requestedIndex=index;
    track.scrollTo({left:targetLeft(index),behavior:reduced.matches?'auto':behavior});
    mark(index);
  }
  function selectThroughOriginal(index){
    const button=buttons()[index];
    if(!button)return;
    if(index!==selected()){
      suppressBaseIndex=index;
      // Reuse the original selection, nutrition rendering, zoom and thumb state.
      button.click();
    }
    mark(index);
  }
  function settle(){
    clearTimeout(settleTimer);
    if(!mobile.matches||touchActive||!track.children.length)return;
    // A cancelled smooth-scroll event must not undo a newer keyboard/thumb target.
    if(requestedIndex!==null&&Math.abs(targetLeft(requestedIndex)-track.scrollLeft)>2)return;
    requestedIndex=null;
    selectThroughOriginal(nearest());
  }
  function queueSettle(){
    clearTimeout(settleTimer);
    settleTimer=setTimeout(settle,140);
  }
  function build(){
    const originals=buttons();
    if(!mobile.matches||!originals.length||track.children.length===originals.length)return;
    const slides=originals.map((button,index)=>{
      const originalArt=button.querySelector('.thumbnail-image');
      if(!originalArt)return null;
      const slide=document.createElement('div');
      slide.className='mgv6-slide';
      slide.dataset.index=String(index);
      slide.setAttribute('role','group');
      slide.setAttribute('aria-label',`${index+1} von ${originals.length}`);
      // Clone the already-approved rendering, including its exact layers/tables.
      const art=originalArt.cloneNode(true);
      art.className='gallery-art mgv6-art';
      const image=art.querySelector(':scope > img');
      image.classList.add('mgv6-image');
      image.alt=button.getAttribute('aria-label')||'';
      image.draggable=false;
      image.loading=index<3?'eager':'lazy';
      art.querySelectorAll('.art-table').forEach(table=>table.removeAttribute('aria-hidden'));
      slide.append(art);
      return slide;
    });
    if(slides.some(slide=>!slide))return;
    track.replaceChildren(...slides);
    gallery.classList.add('mgv6-ready');
    requestAnimationFrame(()=>align(selected()));
  }
  function setMode(){
    clearTimeout(settleTimer);
    touchActive=false;
    requestedIndex=null;
    if(mobile.matches){
      gallery.insertBefore(eyebrow,stage);
      build();
      requestAnimationFrame(()=>align(selected()));
    }else{
      originalPosition.after(eyebrow);
    }
  }

  track.addEventListener('scroll',queueSettle,{passive:true});
  track.addEventListener('scrollend',settle);
  track.addEventListener('wheel',()=>{requestedIndex=null;},{passive:true});
  track.addEventListener('touchstart',()=>{touchActive=true;requestedIndex=null;clearTimeout(settleTimer);},{passive:true});
  track.addEventListener('touchend',()=>{touchActive=false;queueSettle();},{passive:true});
  track.addEventListener('touchcancel',()=>{touchActive=false;queueSettle();},{passive:true});
  track.addEventListener('keydown',event=>{
    if(!mobile.matches||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();
    const index=bounded(event.key==='Home'?0:event.key==='End'?track.children.length-1:selected()+(event.key==='ArrowRight'?1:-1));
    selectThroughOriginal(index);
    align(index,'smooth');
  });
  stage.addEventListener('click',event=>{
    if(mobile.matches&&event.target.closest('.gallery-zoom')){
      if(requestedIndex!==null)selectThroughOriginal(requestedIndex);
      else settle();
    }
  },true);
  new MutationObserver(()=>{
    build();
    const index=selected();
    if(suppressBaseIndex===index){suppressBaseIndex=null;return;}
    if(mobile.matches&&!touchActive)align(index,'smooth');
  }).observe(thumbs,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-pressed']});
  new ResizeObserver(()=>{
    cancelAnimationFrame(alignmentFrame);
    alignmentFrame=requestAnimationFrame(()=>{if(!touchActive)align(selected());});
  }).observe(gallery);
  mobile.addEventListener('change',setMode);
  setMode();
})();

})();

(() => {
  const bar = document.getElementById('m50-stick');
  const offer = document.querySelector('#lst01-abschluss #purchase-options .add-button');
  if (!bar || !offer || !('IntersectionObserver' in window)) return;
  new IntersectionObserver((entries) => {
    bar.hidden = entries[0].isIntersecting;
  }, { rootMargin: '0px 0px -25% 0px' }).observe(offer);
})();
